import { render, staticRenderFns } from "./TheGameLoop.vue?vue&type=template&id=785bbd08&scoped=true&"
import script from "./TheGameLoop.vue?vue&type=script&lang=ts&"
export * from "./TheGameLoop.vue?vue&type=script&lang=ts&"
import style0 from "./TheGameLoop.vue?vue&type=style&index=0&id=785bbd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bbd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
